var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddusercon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45461 10.5322C3.50925 10.5322 1 10.9759 1 12.7584C1 14.5409 3.49395 14.9999 6.45461 14.9999C9.41526 14.9999 11.9016 14.5562 11.9016 12.7737C11.9016 10.9912 9.40761 10.5322 6.45461 10.5322Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45457 7.99235C7.14605 7.99235 7.82204 7.78729 8.39698 7.40312C8.97193 7.01896 9.42003 6.47292 9.68465 5.83408C9.94927 5.19524 10.0185 4.49231 9.88361 3.81411C9.74871 3.13592 9.41572 2.51297 8.92677 2.02402C8.43782 1.53507 7.81487 1.20208 7.13667 1.06718C6.45848 0.932277 5.75551 1.00152 5.11666 1.26614C4.47782 1.53076 3.93178 1.97886 3.54762 2.55381C3.16345 3.12875 2.95844 3.80469 2.95844 4.49617C2.95642 4.95328 3.04447 5.40632 3.21754 5.82941C3.39061 6.2525 3.6453 6.63736 3.96711 6.96201C4.28892 7.28666 4.67153 7.54474 5.09308 7.72153C5.51464 7.89831 5.96687 7.99035 6.42399 7.99235H6.45457Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5847 5.52887V8.58898",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.153 7.06671H12.024",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddusercon);
export default __webpack_public_path__ + "static/media/Addusercon.4d22f21c957cbe36b0b4216aa158e5cf.svg";
export { ForwardRef as ReactComponent };